/* istanbul ignore file */
import { number as codecNumber } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const TierStarterMaxStudentsSettingParser = 
/* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ parsers.exactly('TIER_STARTER_MAX_STUDENTS')],
    ['value', /* #__PURE__ */ parsers.maybeNull(codecNumber)],
]);
export class TierStarterMaxStudentsSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return TierStarterMaxStudentsSettingParser.decode(input).map(res => new TierStarterMaxStudentsSetting(res));
    }
    static unsafeDecode(input) {
        return TierStarterMaxStudentsSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return TierStarterMaxStudentsSettingParser.encode(data);
    }
    static schema() {
        return TierStarterMaxStudentsSettingParser.schema();
    }
}
